import React from 'react';
import { renderComponent, compose, branch } from 'recompose';
import { withForgotPasswordProps } from './ForgotPassword';
import InputField from '../Common/InputField';
import config from '../../config';
import { withTranslationProvider, HTMLTrans } from '../Common/Translations';

const ForgotPasswordPage = ({
  submissionValid,
  email,
  onEmailChange,
  onSubmit,
  t,
}) => {
  return (
    <div className={`${!submissionValid ? 'was-validated' : ''} container py-5 col-md-6`}>
      <h2 className="text-center"><HTMLTrans id='navbar.auth_forgotpasswordpage_title'>Forgot Password</HTMLTrans></h2>
      <div className="mt-3">
        <InputField
            id={'forgot-password-page-email'}
            label={t('navbar.auth_forgotpasswordpage_email_label', 'Your Email:')}
            type='email'
            placeholder={t('navbar.auth_forgotpasswordpage_email_placeholder', 'Email')}
            value={email}
            onChange={onEmailChange}
            required
            formClass='form-group mt-3'
            labelClass='ProximaNova-Bold'
            {...!email && { invalidFeedback: t('navbar.auth_forgotpasswordpage_invalid_feedback_email', 'Please fill in your email.') }}
          />
        <div className="text-center">
          <button
              type="button"
              onClick={onSubmit}
              className="btn btn-lg btn-primary"><HTMLTrans id='navbar.auth_forgotpasswordpage_submit_button'>SUBMIT</HTMLTrans></button>
        </div>
      </div>
    </div>
  );
};

export const showSuccessSubmission = (props) => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='mt-5 col-12'>
          <h3>{props.successMessage}</h3>
          <div className='mb-5'>
            <a href={config.taopixStoreUrl}>
              <button type="button" className="btn btn-lg btn-primary"><HTMLTrans id='navbar.auth_forgotpasswordpage_click_to_login'>Click to Login</HTMLTrans></button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const hasSubmittedRequest = branch(
  props => props.isSubmitted,
  renderComponent(showSuccessSubmission),
);

const enhance = compose(
  withTranslationProvider,
  withForgotPasswordProps,
  hasSubmittedRequest,
)(ForgotPasswordPage);

export default enhance;
export const undecorated = ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/Auth/ForgotPasswordPage.js